import cookie from 'react-cookies';
import hexToRgba from 'hex-rgba';

// Constants.
import { PROFILE_STATUS_SELF_SERVICE, PROFILE_STATUS_MONITORING } from 'constants/ProfileConstants';

export function isPageSpeed() {
  return window.navigator.userAgent.indexOf('Speed Insights') !== -1;
}

export function isIOS() {
  return /iPhone|iPad|iPod/i.test(window.navigator.userAgent);
}

export function isAndroidOS() {
  return /Android/i.test(window.navigator.userAgent);
}

export function isIOSApp() {
  const { navigator } = window;
  const standalone = navigator.standalone;
  const userAgent = navigator.userAgent.toLowerCase();
  const safari = /safari/.test(userAgent);
  const ios = /iphone|ipod|ipad/.test(userAgent);

  if (ios) {
    if (!standalone && !safari) {
      return true;
    }
  }
  return false;
}

export function isAndroidApp() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const android = /android/.test(userAgent);
  return android && /welltory/.test(userAgent);
}

export function isWebviewApp() {
  return isIOSApp() || isAndroidApp();
}

export function isMobile() {
  return /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
}

export function isWelltoryNewsfeedVersion() {
  const appName = 'welltory/3';
  const userAgent = window.navigator.userAgent.toLowerCase();
  return true;
  return userAgent.indexOf(appName) !== -1;
}

export function getCookie(name) {
  const cookies = window.document.cookie.split(';');
  const cookie = cookies.map((cookie) => {
    const matches = cookie.match(new RegExp(name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  });
  const cookieWithoutUndefined = cookie.filter((item) => { if (item !== 'undefined') { return item;} return null; })
  return cookieWithoutUndefined.pop();
}

export function setCookie(name, value) {
  cookie.save(name, value, { domain: '.welltory.com', path: '/' });
}

export function isFreeUser(userState) {
  return userState !== 'customer';
}

export function isDemoUser(auth, profile) {
  if (!auth.isAuthenticated) {
    return true;
  }
  return isFreeUser(profile.user_state);
}

export function isSelfServiceUser(subscriptionStatus) {
  return subscriptionStatus === PROFILE_STATUS_SELF_SERVICE;
}

export function isMonitoringUser(subscriptionStatus) {
  return subscriptionStatus === PROFILE_STATUS_MONITORING;
}

export function getLanguage() {
  let language = '';
  if (window.navigator.languages && window.navigator.languages.length > 0) {
    const languages = window.navigator.languages.join(',');
    const ruPos = languages.indexOf('ru');
    const enPos = languages.indexOf('en');
    if (ruPos === -1 && enPos !== -1) {
      language = 'en';
    }
    else if (ruPos !== -1 && enPos === -1) {
      language = 'ru';
    }
    else if (ruPos < enPos) {
      language = 'ru';
    }
    else if (ruPos > enPos) {
      language = 'en';
    }
  }
  else {
    language = window.navigator.language || 'ru';
  }
  language = language.split('-')[0];
  if (language !== 'ru' && language !== 'en') {
    language = 'en';
  }
  return language;
}

export function getLocalData(type, wid, defaultValue) {
  const status = JSON.parse(window.localStorage.getItem(type));
  return (status && status[wid] !== undefined) ? status[wid] : defaultValue;
}

export function setLocalData(type, value, wid) {
  const currentState = JSON.parse(window.localStorage.getItem(type)) || {};
  currentState[wid] = value;
  return window.localStorage.setItem(type, JSON.stringify(currentState));
}

export function deleteLocalData(type) {
  return window.localStorage.removeItem(type);
}

export function declOfNum(number, titles) {
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
}

export function isSharedDashboard() {
  if (getCookie('login_token') !== undefined) {
    return true;
  }
  return false;
}

export function reverse(array) {
  var output = [];
  while(array.length){
    output.push(array.pop());
  }

  return output;
}

const colors = `<?xml version="1.0" encoding="utf-8"?>
<!--Внимание!-->
<!--Все цвета должны содержать aplha компоненту. Это важно для парсера SwiftGen.-->
<!--Поддерживается ТОЛЬКО формат #AARRGGBB. Формат #RRGGBB использовать нельзя!-->
<resources>
    <color name="ns_awake">#FF89A3FF</color>
    <color name="ns_body">#FFF09D9D</color>
    <color name="ns_brand">#FFFF4200</color>
    <color name="ns_brand_2">#FFFF8567</color>
    <color name="ns_breakfast">#FF52B692</color>
    <color name="ns_breathing">#FFC2CFFD</color>
    <color name="ns_carbs">#FF299A71</color>
    <color name="ns_cardio">#FFEFDD36</color>
    <color name="ns_coffee">#FF8A472A</color>
    <color name="ns_cold_1">#FF1CD8DA</color>
    <color name="ns_cold_3">#FF1A87F5</color>
    <color name="ns_dark_grey">#FF646B80</color>
    <color name="ns_dinner">#FF6B214D</color>
    <color name="ns_fat">#FFE3D142</color>
    <color name="ns_fon_1">#FFEAEEF0</color>
    <color name="ns_green">#FF03CB34</color>
    <color name="ns_grey_6">#FFC0C3CD</color>
    <color name="ns_grey_6_40">#66C0C3CD</color>
    <color name="ns_grey_9">#FF81889C</color>
    <color name="ns_ink">#FF151A22</color>
    <color name="ns_ink_15">#26151A22</color>
    <color name="ns_ink_40">#66151A22</color>
    <color name="ns_love">#FFFFB3D9</color>
    <color name="ns_meditation">#FFB366EF</color>
    <color name="ns_meditation_2">#FF4A6ED9</color>
    <color name="ns_productivity_1">#FF53797A</color>
    <color name="ns_productivity_2">#FF8CC4C5</color>
    <color name="ns_protein">#FF7E6BC7</color>
    <color name="ns_red">#FFFF003F</color>
    <color name="ns_sex">#FFFF73B3</color>
    <color name="ns_sleep_1">#FF0D3096</color>
    <color name="ns_sleep_2">#FF001A66</color>
    <color name="ns_sleep_3">#FF2149BE</color>
    <color name="ns_snack">#FFE4246E</color>
    <color name="ns_stress">#FFE83E35</color>
    <color name="ns_warm_1">#FFFF8F30</color>
    <color name="ns_warm_2">#FFFF6060</color>
    <color name="ns_water">#FF23AAEA</color>
    <color name="ns_weather">#FF86ADD6</color>
    <color name="ns_white">#FFFFFFFF</color>
    <color name="ns_white_1_70">#B3FFFFFF</color>
    <color name="ns_white_2_30">#4DFFFFFF</color>
    <color name="ns_white_3_15">#26FFFFFF</color>
    <color name="ns_workouts_1">#FFA2D23B</color>
    <color name="ns_workouts_2">#FF0F9D48</color>
    <color name="ns_yellow">#FFF0B60A</color>
	  <color name="ns_not_active">#FFDCDCDC</color>
</resources>
`;

export function setColor(color) {
  if (window.colors === undefined) {
    window.colors = [];

    const parser = new DOMParser();
    const colorsList = parser.parseFromString(colors, 'text/xml');
    const colorsCollection = colorsList.getElementsByTagName('color');
    if (colorsCollection.length > 0) {
      for (let i = 0; i < colorsCollection.length; i++) {
        const color = colorsCollection[i];
        const colorKey = color.getAttributeNode('name').value.replace('ns_', '');
        const colorValue = color.firstChild.nodeValue.replace('#', '');
        let colorOpacity;
        let colorRgba;
        if (colorValue.length === 8) {
          colorOpacity = Math.floor(parseInt(colorValue.slice(0, 2), 16) / 255 * 100);
          colorRgba = hexToRgba(`#${colorValue.slice(2, 8)}`, colorOpacity);
        }
        else {
          colorOpacity = 100;
          colorRgba = hexToRgba(`#${colorValue.slice(0, 6)}`, colorOpacity);
        }
        window.colors[colorKey] = colorRgba;
      }
    }
  }
  if (window.colors !== undefined && window.colors[color] !== undefined) {
    return window.colors[color];
  }
  return color;
}

export const getConsentsVersion = () => {
  const consentsVersion = '1.0.0';
  return consentsVersion;
}

export const getTermsVersion = () => {
  const termsVersion = '2025-01-01';
  return termsVersion;
}

export const getPrivacyPolicyVersion = () => {
  const privacyPolicyVersion = '2025-01-01';
  return privacyPolicyVersion;
}

export const getConsentsMarketingEmailText = () => {
  const marketingEmailText = 'I explicitly agree to receive communications from Welltory Inc. about new features, research studies, and special offers developed with selected partners to support my health and wellness. I understand that I can withdraw this consent or unsubscribe at any time';
  return marketingEmailText;
}

export const getConsentsRejectCookiesText = () => {
  return 'Reject Non-Essential Cookies';
}

export const getConsentsAcceptAllCookiesText = () => {
  return 'Accept All Cookies';
}

export const getConsentsAcceptCookiesText = () => {
  return 'Save and continue';
}

export const iubendaPreferences = {
  NECESSARY: "1",
  FUNCTIONALITY: "2",
  MEASUREMENT: "4",
  MARKETING: "5",
};

export const isAcceptAllCookies = (prefs) => {
  const purposes = prefs?.purposes ?? {};
  const values = Object.values(purposes);
  return values.length > 0 && values.every(Boolean);
}

export const getAcceptTypes = (prefs) => {
  const purposes = prefs?.purposes ?? {};
  return {
    cookie_functionality: !!purposes[iubendaPreferences.FUNCTIONALITY],
    cookie_measurement: !!purposes[iubendaPreferences.MEASUREMENT],
    cookie_marketing: !!purposes[iubendaPreferences.MARKETING],
  };
}

export const deleteAnalyticsCookies = () => {
  const cookies = document.cookie.split(';');
  const cookieAnalytics = [
    '_ga',
    '_gid',
    '_gat',
    'gaVisitorUuid',
    '_gcl_au',
    '__utma',
    '__utmz',
    'AMP_',
    'amplitude_id_',
    'amp_',
    '_fbp',
    'fr',
    '_tt_',
    '_ttp',
    'ttcsid',
    'tt_sessionId',
    'ttcsid_',
  ]
  cookies.forEach((cookie) => {
    const name = cookie.split('=')[0].trim();

    cookieAnalytics.forEach(cookieAnalytic => {
      if (name.startsWith(cookieAnalytic)) {
        document.cookie = `${name}=; Path=/; Domain=.welltory.com; Max-Age=0;`;
      }
    });
  })
}

export const deleteFunctionalCookies = () => {
  const cookies = document.cookie.split(';');
  const cookieAnalytics = [
    'intercom',
  ]
  cookies.forEach((cookie) => {
    const name = cookie.split('=')[0].trim();

    cookieAnalytics.forEach(cookieAnalytic => {
      if (name.startsWith(cookieAnalytic)) {
        document.cookie = `${name}=; Path=/; Domain=.welltory.com; Max-Age=0;`;
      }
    });
  })
}